import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Breadcrumb = ({
	data,
}) => (
	<ul className="breadcrumb margin-bottom-16">
		{data ? (
			data.map((page, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<li key={index} className="margin-right-8">
					{page.url ? (
						<Link to={page.url}>{page.name}</Link>
					) : (
						page.name
					)}
				</li>
			))) : null}
	</ul>
);

export default Breadcrumb;

Breadcrumb.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		url: PropTypes.string,
	})).isRequired,
};
